









































































import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'ProfileEv',
  // props: {
  // },
  components: {},
  setup: () => {
    return {};
  }
});
